import React from 'react';
import { NavLink } from 'react-router-dom';

const PageNavAccount = () => {

    return (
        <nav>
            <ul className='flex justify-center gap-4 sm:gap-6 md:gap-8 sm:justify-start items-center text-xs sm:text-sm mt-8 border-b border-custom-charcoal'>

                <li className=''>
                    <NavLink 
                        to="/account/overview"
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Overview
                    </NavLink>
                </li>
                <li className=''>
                    <NavLink 
                        to="/account/edit"
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Manage Account
                    </NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default PageNavAccount;